export const Capabilities = Object.freeze({
    ACCOUNTREFER: 'accountrefer',
    BLF: 'blf',
    CALENDAR: 'calendar',
    CC_PRO: 'desktopcc',
    CENTREX: 'centrex',
    WHATSAPP_CHANNEL: 'whatsapp_channel',
    EMAIL_CHANNEL_MICROSOFT: 'email_channel_microsoft',
    CHAT: 'chat',
    CONFERENCE: 'conference',
    CONTACTLIST: 'contactlist',
    DESK_PHONE_READY: 'desk_phone_ready',
    DISA: 'disa',
    EXTERNAL_CALLS: 'external_calls',
    FIXED_PHONE_NUMBER: 'fixed_phone_number',
    MOBILEEXTENSION: 'mobileextension',
    PRESENCE: 'presence',
    PROFILES: 'profiles',
    QUEUE_MEMBERSHIPS: 'queue_memberships',
    REDIRECT: 'redirect',
    SCREEN_SHARING: 'screen_sharing',
    SIPUSER: 'sipuser',
    SMS: 'sms',
    SOFTPHONE: 'softphone',
    SOUND: 'sound',
    SPEEDDIAL: 'speeddial',
    USER_APP_ACCESS: 'user_app_access',
    USERPAGE: 'userpage',
    VIDEO: 'video',
    VOICEMAIL: 'voicemail',
    TICKETS: 'tickets',
    MICROSOFT_CALENDAR_SYNC: 'microsoft_calendar_sync',
    GOOGLE_CALENDAR_SYNC: 'google_calendar_sync',
    MICROSOFT_CONTACT_SYNC: 'microsoft_contact_sync',
    GOOGLE_CONTACT_SYNC: 'google_contact_sync',
    VIDEO_1_ON_1: 'video_1_on_1',
    GROUP_SMS: 'group_sms',
    TRANSCRIBE_ON_CALL: 'transcribe_on_call',
    PERSONAL_TRANSCRIPTION: 'personal_transcription',
    BUSINESS_TRANSCRIPTION: 'business_transcription',
});
